import { Leaf } from "lucide-react";

const ITEMS = [
  "Kachi Ghani",
  "Wooden Ghani Pressed",
  "Below 45°C",
  "No Chemicals",
  "No Preservatives",
  "Small Batches",
  "Lab Tested",
  "Single Ingredient",
];

export const Marquee = () => {
  const row = (
    <div className="flex shrink-0 items-center">
      {ITEMS.map((item) => (
        <span key={item} className="flex items-center">
          <span className="mx-8 font-serif italic text-2xl md:text-3xl text-cream/80 whitespace-nowrap">
            {item}
          </span>
          <Leaf size={16} className="text-gold/60 shrink-0" />
        </span>
      ))}
    </div>
  );

  return (
    <div
      data-testid="editorial-marquee"
      className="relative overflow-hidden border-y border-gold/20 bg-ink py-6"
    >
      <div className="animate-marquee flex w-max">
        {row}
        {row}
      </div>
    </div>
  );
};
